import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PermissionGroup, UserRoleMapping } from "src/app/models/user-management/permission-group";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private http: HttpClient) { }

  getAllPermissionGroup(): Observable<PermissionGroup[]> {
    return this.http.get<PermissionGroup[]>(`${environment.api}/user-management/permission-group`);
  }

  getPermissionGroupById(id: number): Observable<PermissionGroup> {
    return this.http.get<PermissionGroup>(`${environment.api}/user-management/permission-group/${id}`);
  }

  createPermissionGroup(request: PermissionGroup): Observable<any> {
    return this.http.post<any>(`${environment.api}/user-management/permission-group`, request, { headers: this.headers });
  }

  updatePermissionGroup(request: PermissionGroup): Observable<any> {
    return this.http.put<any>(`${environment.api}/user-management/permission-group`, request, { headers: this.headers });
  }

  deletePermissionGroups(permissionGroupId: number): Observable<any> {
    return this.http.delete<any>(`${environment.api}/user-management/permission-group/${permissionGroupId}`);
  }

  getUserRoleMappingByUserId(userId: number): Observable<UserRoleMapping> {
    return this.http.get<UserRoleMapping>(`${environment.api}/user-management/user/role-mapping/${userId}`);
  }

  createUserRoleMapping(request: UserRoleMapping): Observable<any> {
    return this.http.post<any>(`${environment.api}/user-management/user/role-mapping`, request, { headers: this.headers })
  }

  updateUserRoleMapping(request: UserRoleMapping): Observable<any> {
    return this.http.put<any>(`${environment.api}/user-management/user/role-mapping`, request, { headers: this.headers })
  }
}
